import React from "react";
import { Modal, ModalBody } from "@windmill/react-ui";
import CommonCloseBtn from "components/CloseButton/CommonCloseButton";

const ViewCityVendorEnquiryModal = ({ data, onClose, loading }) => {
  const result = data;

  const style = `
    .custom-modal {
      overflow: hidden;
    }
    .scroll-container {
      max-height: 70vh;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: #999 #f0f0f0;
    }
    .scroll-container::-webkit-scrollbar {
      width: 6px;
    }
    .scroll-container::-webkit-scrollbar-thumb {
      background-color: #999;
      border-radius: 10px;
    }
    .scroll-container::-webkit-scrollbar-track {
      background: #f0f0f0;
    }
  `;

  return (
    <>
      <style>{style}</style>

      <Modal
        className="relative bg-white dark:bg-gray-800 dark:text-white w-full sm:w-11/12 md:w-3/4 lg:w-1/2 max-w-4xl rounded-lg shadow-lg"
        isOpen={true}
        onClose={onClose}
      >
        <ModalBody className="custom-modal px-4 py-5">
          {loading ? (
            <p className="text-center">Loading...</p>
          ) : (
            <div>
              <CommonCloseBtn onClose={onClose} />
              <h2 className="text-center font-bold text-lg mb-4">
                Vendor Details
              </h2>

              {/* Scrollable section */}
              <div className="scroll-container p-2 sm:p-4">
                <dl className="border rounded-lg border-gray-300 dark:border-gray-600 text-sm sm:text-base">
                  {/* Basic Info */}
                  {[
                    ["Company Name", result?.company_name],
                    ["Authorized Person Name", result?.full_name],
                    ["City", result?.city_name],
                    ["State", result?.state_name],
                    ["No. of Employees", result?.no_of_employees],
                    ["No. of Fleet", result?.no_of_fleet],
                    ["Company Age", result?.company_age],
                    ["Contact Number", result?.contact_no],
                    ["Alternate Contact", result?.alt_contact_no],
                    ["Vendor Reason", result?.vendor_reason],
                  ].map(([label, value]) => (
                    <div
                      key={label}
                      className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4 p-3 border-b border-gray-200 dark:border-gray-700"
                    >
                      <dt className="font-semibold text-gray-900 dark:text-gray-200">
                        {label}
                      </dt>
                      <dd className="text-gray-700 dark:text-gray-300 sm:col-span-2 break-words whitespace-pre-wrap max-w-full">
                        {value || "-"}
                      </dd>
                    </div>
                  ))}

                  {/* Vehicle Count */}
                  {result?.vehicle_count && (
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4 p-3 border-t border-gray-200 dark:border-gray-600">
                      <dt className="font-semibold text-gray-900 dark:text-gray-200">
                        Vehicle Details
                      </dt>
                      <dd className="text-gray-700 dark:text-gray-300 sm:col-span-2">
                        {Object.entries(result.vehicle_count).map(
                          ([vehicle, count]) => (
                            <div key={vehicle} className="break-words">
                              {vehicle}: {count}
                            </div>
                          ),
                        )}
                      </dd>
                    </div>
                  )}

                  {/* Other Counts */}
                  {result?.other_count &&
                    Object.keys(result.other_count).length > 0 && (
                      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 sm:gap-4 p-3 border-t border-gray-200 dark:border-gray-600">
                        <dt className="font-semibold text-gray-900 dark:text-gray-200">
                          Other Details
                        </dt>
                        <dd className="text-gray-700 dark:text-gray-300 sm:col-span-2">
                          {Object.entries(result.other_count).map(
                            ([key, value]) => (
                              <div key={key} className="break-words">
                                {key}: {value}
                              </div>
                            ),
                          )}
                        </dd>
                      </div>
                    )}
                </dl>
              </div>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default React.memo(ViewCityVendorEnquiryModal);
